export default __webpack_public_path__ + "static/line_tool.ea0bd669c673e666ccef7698d2386e14.svg";